<div class="modal-header">
  <h4 class="modal-title">
    <ng-container *ngIf="isEdit">{{ 'admin:tags:modal:title:edit' | translate }}</ng-container>
    <ng-container *ngIf="!isEdit">{{ 'admin:tags:modal:title:new' | translate }}</ng-container>
  </h4>
  <button type="button" class="btn-close" (click)="closeModal()"></button>
</div>

<div class="modal-body">
  <ul class="nav nav-tabs mb-3">
    <li class="nav-item" *ngFor="let lang of languages">
      <a
        class="nav-link"
        [class.active]="activeLang === lang"
        href="javascript:void(0)"
        (click)="setActiveLang(lang)"
      >
        {{ lang | uppercase }}
        <span
          *ngIf="translations[lang].name.trim().length"
          class="ms-1 text-success"
          title="Filled"
        >•</span>
      </a>
    </li>
  </ul>

  <div *ngFor="let lang of languages" [hidden]="activeLang !== lang">
    <div class="mb-3">
      <label class="form-label">
        {{ 'admin:tags:modal:field:name' | translate }} ({{ lang | uppercase }})
      </label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="translations[lang].name"
        [placeholder]="'admin:tags:modal:field:name:placeholder' | translate"
      />
    </div>

    <div class="mb-3">
      <label class="form-label">
        {{ 'admin:tags:modal:field:description' | translate }} ({{ lang | uppercase }})
      </label>
      <textarea
        class="form-control"
        rows="3"
        [(ngModel)]="translations[lang].description"
        [placeholder]="'admin:tags:modal:field:description:placeholder' | translate"
      ></textarea>
    </div>
  </div>

  <hr />

  <div class="mb-3">
    <label class="form-label">
      {{ 'admin:tags:modal:field:parent' | translate }}
    </label>

    <div *ngIf="parentTag" class="d-flex align-items-center">
      <span class="badge bg-primary d-inline-flex align-items-center">
        {{ parentTag.name }}
        <button
          type="button"
          class="btn-close btn-close-white ms-2"
          style="font-size: 0.6rem;"
          (click)="clearParent()"
        ></button>
      </span>
    </div>

    <div *ngIf="!parentTag" class="parent-search-container position-relative">
      <input
        type="text"
        class="form-control"
        [ngModel]="parentSearch"
        (ngModelChange)="onParentSearchChange($event)"
        [placeholder]="'admin:tags:modal:field:parent:placeholder' | translate"
      />
      <i *ngIf="parentSearching" class="fa fa-circle-notch fa-spin text-primary parent-search-spinner"></i>

      <div class="parent-results" *ngIf="parentShowResults && parentSearch.length">
        <a
          *ngFor="let opt of parentResults"
          class="parent-result-item"
          href="javascript:void(0)"
          (click)="selectParent(opt)"
        >
          {{ opt.name }}
        </a>
        <div *ngIf="!parentSearching && !parentResults.length" class="parent-result-empty">
          {{ 'admin:tags:modal:field:parent:empty' | translate }}
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="dhOrganization">
    <hr />

    <div class="d-flex justify-content-between align-items-center mb-2">
      <label class="form-label mb-0">
        {{ 'admin:tags:modal:field:contexts' | translate }}
      </label>
      <button type="button" class="btn btn-sm btn-outline-primary" (click)="addContext()">
        <i class="fa fa-plus me-1"></i>
        {{ 'admin:tags:modal:field:contexts:add' | translate }}
      </button>
    </div>

    <p *ngIf="!contexts.length" class="text-muted fs-14 mb-0">
      {{ 'admin:tags:modal:field:contexts:empty' | translate }}
    </p>

    <div *ngFor="let ctx of contexts; let i = index" class="row g-2 mb-2 align-items-center">
      <div class="col">
        <select class="form-select form-select-sm" [(ngModel)]="ctx.phase">
          <option [ngValue]="null" disabled>
            {{ 'admin:tags:modal:field:contexts:field' | translate }}
          </option>
          <option *ngFor="let p of phases" [ngValue]="p">
            {{ 'admin:tags:modal:field:contexts:field' | translate }} {{ p }}
          </option>
        </select>
      </div>
      <div class="col">
        <select class="form-select form-select-sm" [(ngModel)]="ctx.level">
          <option [ngValue]="null" disabled>
            {{ 'admin:tags:modal:field:contexts:level' | translate }}
          </option>
          <option *ngFor="let l of levels" [ngValue]="l">
            {{ 'admin:tags:modal:field:contexts:level' | translate }} {{ l }}
          </option>
        </select>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeContext(i)">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>
  </div>

  <hr />

  <div class="form-check form-switch">
    <input
      class="form-check-input"
      type="checkbox"
      id="tagVerifiedToggle"
      [(ngModel)]="verified"
    />
    <label class="form-check-label" for="tagVerifiedToggle">
      {{ 'admin:tags:modal:field:verified' | translate }}
    </label>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="closeModal()" [disabled]="saving">
    {{ 'admin:tags:modal:cancel' | translate }}
  </button>
  <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving">
    <i *ngIf="saving" class="fa fa-circle-notch fa-spin me-1"></i>
    <ng-container *ngIf="isEdit">{{ 'admin:tags:modal:save' | translate }}</ng-container>
    <ng-container *ngIf="!isEdit">{{ 'admin:tags:modal:create' | translate }}</ng-container>
  </button>
</div>
